/**
 * Shared constants for KPI pages
 */

import { getDefaultDateRange } from "../utils/defaultDateRange";

export const AGGREGATION_LEVELS = ["15mins", "hourly", "daily"];

export const DEFAULT_PAGE_SIZE = 11;

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const INITIAL_PAGINATION = {
  count: 0,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export const KPI_ENDPOINTS = {
  TRAFFIC_SPEED: "/kpi/get_traffic_pivot/",
  USER_COUNT: "/kpi/get_usercount_pivot/",
  TURN_COUNT: "/kpi/get_turncount_pivot/",
  SPEED_STATS: "/kpi/get_speed_stats/",
};

export const KPI_PAGE_CONFIG = {
  trafficSpeed: {
    title: "Speed Distribution",
    subtitle: "Vehicle Distribution by Speed",
    endpoint: KPI_ENDPOINTS.TRAFFIC_SPEED,
    chartTitle: "Traffic Speed Insights",
    chartSubtitle: "Vehicle Distribution by Speed",
    tableTitle: "Vehicle Distribution by Speed",
    sessionStorageKey: "kpiFilter",
    defaultFilters: () => ({
      systemId: "1",
      interval: "3",
      ...getDefaultDateRange(),
      aggregationLevel: "hourly",
    }),
  },
  userCount: {
    title: "Movement Counts Over Time",
    subtitle: "Movement Counts Over Time by User Type",
    endpoint: KPI_ENDPOINTS.USER_COUNT,
    chartTitle: "Movement Counts Over Time",
    chartSubtitle: "Movement Counts Over Time by User Type",
    tableTitle: "User Count Data",
    sessionStorageKey: "userCountFilter",
    defaultFilters: () => ({
      systemId: "1",
      interval: "3",
      ...getDefaultDateRange(),
      aggregationLevel: "15mins",
    }),
    showSummaryStats: true,
  },
  turnCount: {
    title: "Movement Counts",
    subtitle: "Movements by Lane",
    endpoint: KPI_ENDPOINTS.TURN_COUNT,
    chartTitle: "Movement Counts",
    chartSubtitle: "Movements by Lane",
    tableTitle: "Turn Count Data",
    sessionStorageKey: "turnCountFilter",
    availableUserTypes: ['Vehicle', 'Pedestrian', 'Cyclist'],
    defaultFilters: () => ({
      systemId: "1",
      ...getDefaultDateRange(),
    }),
    showSummaryStats: true,
    columnMapping: {
      source: ['entry_street', 'entry_side', 'entry_lane'],
      target: ['exit_street', 'exit_side', 'exit_lane'],
      value: 'value'
    }
  },
  speedStats: {
    title: "Speed Statistics",
    subtitle: "Mean Vehicle Speeds & Percentiles",
    endpoint: KPI_ENDPOINTS.SPEED_STATS,
    chartTitle: "Percentiles Over Time",
    chartSubtitle: "Speed Percentile Distribution",
    tableTitle: "Speed Percentile Data",
    sessionStorageKey: "speedStatsFilter",
    defaultFilters: () => ({
      systemId: "1",
      ...getDefaultDateRange(),
    }),
  },
};